import styled from '@emotion/styled';
import { LuxTypography } from '@gemini/fe-ds-core';

export const TypographyDesktop = styled(LuxTypography)({
  display: 'flex',
  '@media screen and (max-width: 576px)': {
    display: 'none',
  },
});

export const TypographyMobile = styled(LuxTypography)({
  display: 'none',
  '@media screen and (max-width: 576px)': {
    display: 'flex',
  },
});

export const HeaderWrapper = styled.div<{
  noSignIn: boolean;
  isForTypWidget: boolean;
  centered?: boolean;
  borderBottom?: boolean;
}>`
  background-color: #fff;
  width: 100%;
  min-height: 4.75rem;
  height: 4.75rem;
  padding: 1rem;
  display: flex;
  justify-content: ${props =>
    props.centered
      ? 'center'
      : props.noSignIn
        ? 'flex-start'
        : 'space-between'};
  align-items: center;
  position: ${props => (props.isForTypWidget ? 'unset' : 'sticky')};
  top: 0;
  z-index: 2;
  border-bottom: ${props =>
    props.borderBottom ? '1px solid #d8d8d8' : 'unset'};
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const TitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
